import Vue from 'vue'
import App from './App.vue'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueClipBoard from 'vue-clipboard2'
import Utils from '@/utils/date.js'
import String from '@/utils/util.js'

import qs from 'qs';
Vue.prototype.$qs = qs;

Vue.use(VueClipBoard)
Vue.use(ElementUI);

Vue.prototype.pageGroup = {
	index: 1,
	size: 10,
	sizes: [10, 20, 50, 100],
	total: 0
} //表格分页变量
Vue.prototype.utils = Utils;
Vue.prototype.SString = String;

import store from './store'
import router from './router'

const search = new Vue({
	searchText: '', // 语言标识
})

Vue.config.productionTip = false

new Vue({
	router,
	store,
	data: {
		searchText: '',
		loginShow: false,
	},
	render: h => h(App),
}).$mount('#app')